// React y Hooks
import React, { useEffect, useState } from 'react'
// Third-party libraries
import { useHistory } from 'react-router-dom'
import { connect } from "react-redux"
import Modal from 'antd/es/modal';
import DataTable from 'react-data-table-component';
// Material UI components
import withStyles from '@material-ui/core/styles/withStyles'
import { Container, Grid, Backdrop, CircularProgress,Typography } from '@material-ui/core'
// Local files
import { ColumnsOrderDetailReceipt } from './ColumnsOrderDetailReceipt'
import { customStyleSecondary } from '../../common/CommonStyles'
import { OtherTransactionsStyles } from '../OtherTransactionsStyles'
import ExpandedComponent from './ExpandedComponent'
import OrderDetailReceiptAdd from './OrderDetailReceiptAdd'
import ModalCommon from '../../common/Modal/ModalCommon'
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
    customButton: {
      "&.MuiIconButton-root": { color: "rgba(0, 0, 0, 0.87)" },
      "&.MuiIconButton-root.Mui-disabled": { color: "rgba(0, 0, 0, 0.26)" }
    }
  }));


const OrderDetailReceipt = ({ classes, t, setCompletReceipt, ...props }) => {
    // Routing
    const history = useHistory()
    //Get params from url
    const { match: { params } } = props;
    // UI states
    const [openBackdrop, setOpenBackdrop] = useState(false);
    const [allowAddReceipt, setAllowAddReceipt] = useState(false);
    // Datatable data state
    const [data, setData] = useState([]);
    const [rowDeleteReceipt, setRowDeleteReceipt] = useState({});
    const [filteredItems, setFilteredItems] = useState([]);
    const [openModalDeleteReceipt, setOpenModalDeleteReceipt] = useState(false);
    const ButtonClass = useStyles();
    // config of pagination for DataTable
    const paginationOptions = {
        rowsPerPageText: t('commonMessages.rowsPerPage'),
        rangeSeparatorText: t('common.to'),
        selectAllRowsItem: true,
        selectAllRowsItemText: t('common.all')
    }

    const handleCloseBackdrop = () => {
        setOpenBackdrop(false);
    }
    const handleOpenBackdrop = () => {
        setOpenBackdrop(true);
    }

    useEffect(() => {
        fetchOrderDetailReceipt();
        props.actions.fetch_receipt_services_free_by_order(
            props.userLanguage,
            props.userToken,
            params.pymtOrdId,
            () => ("Error"),
            onSuccessFreeServices
        )
    }, [])// eslint-disable-line react-hooks/exhaustive-deps

    const onSuccessFreeServices = (resp) => {
        setAllowAddReceipt(resp.length);
    }

    const fetchOrderDetailReceipt = () => {
        handleOpenBackdrop()
        props.actions.fetch_Order_receipts_by_order(
            props.userLanguage,
            props.userToken,
            params.pymtOrdId,
            onError,
            onSuccessOrderDetailReceipt
        )
    }

    const onSuccessOrderDetailReceipt = (response) => {
        handleCloseBackdrop();
        setData(response);
        setFilteredItems(response);
    }

    const AddOrderDetailReceipt = (item) => {
        setData([item, ...data]);
        setFilteredItems([...filteredItems, item]);
    }

    const onError = (err) => {
        handleCloseBackdrop()
        if (err.response && err.response.status) {
            switch (err.response.status) {
                case 401:
                    props.tokenExpired()
                    history.push('/login')
                    return;
                case 403:
                    history.push('/forbidden')
                    return;
                default:
                    break
            }
        }
        Modal.error({
            title: 'Error',
            content: t('commonMessages.alert500')
        })
    }
    // call to the delete invoice function
    const DeleteOrderReceiptsByOrder = () => {
        onCloseModal();
        handleOpenBackdrop()
        props.actions.DeleteOrderReceiptsByOrder(props.userLanguage, props.userToken, rowDeleteReceipt.pymtOrdReceiptId,params.pymtOrdId, onError, onSuccessDeleteReceiptsByOrder);
    }
    // Open modal
    const onOpenModal = (row) => {
        setRowDeleteReceipt(row)
        setOpenModalDeleteReceipt(true);

    }

    // Close modal
    const onCloseModal = () => {
        setOpenModalDeleteReceipt(false);
        document.body.style.overflow="initial";
    }
    const onSuccessDeleteReceiptsByOrder = (response) => {
        setCompletReceipt(false);
        handleCloseBackdrop();
        Modal.success({
            content: t('OrderInvoceChange.ModalDeleteInvoice.MessageSuccessDelete'),
            onOk: () => okModalDelete(response)
        })

    }
    const okModalDelete = (resp) => {
        //setAllowAddReceipt(resp.length==0);
        handleCloseBackdrop();
        setData(resp);
        setFilteredItems(resp);
        props.actions.fetch_receipt_services_free_by_order(
            props.userLanguage,
            props.userToken,
            params.pymtOrdId,
            () => ("Error"),
            onSuccessFreeServices
        )
        setTimeout(() => {
            onCloseModal();
          },1000)
    }

    const handleDownloadDocument = (documentId) => {
        handleOpenBackdrop()
        props.actions.download_document_by_id(
            props.userLanguage,
            props.userToken, 
            {DocumentId: documentId, IsInvoice: false}, 
            onError, onSucessDownloadDocument
        )
    }

    const onSucessDownloadDocument = () => {
        handleCloseBackdrop();
        props.actions.fetch_Order_receipts_by_order(
            props.userLanguage,
            props.userToken,
            params.pymtOrdId,
            onError,
            onSuccessOrderDetailReceipt
        )
    }

    return (
        <>
            <ModalCommon
                title={t(`OrderDetailReceipt.ModalDeleteReceipt.Title`)}
                status='default'
                open={openModalDeleteReceipt}
                clickOpen={onCloseModal}
                clickSubmit={DeleteOrderReceiptsByOrder}
                submitButtonOff={false}
                closeButtonOff={false}
                submitButtonTitle={t(`OrderDetailReceipt.ModalDeleteReceipt.ToolTipBlbBtnAccept`)}
                closeButtonTitle={t(`common.cancel`)}
                maxWidth='xs'
                fontSize="2rem"
                variant="h6"
                children={<>
                    <br />
                    <Typography className={classes.White} style={{ textAlign: "center" }}>
                        <ErrorOutlineIcon style={{ fontSize: '60px', color: "#93721E" }} />
                    </Typography>
                    <br />
                    <Typography className={classes.White} style={{ textAlign: "center" }}>
                        <b>
                            {t(`OrderDetailReceipt.ModalDeleteReceipt.MessageBody`)}
                        </b>
                    </Typography>
                </>}
            ></ModalCommon>

            <Container className={classes.generalBorder}>
                <Backdrop className={classes.backdrop} open={openBackdrop}>
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Grid container item xs={12} spacing={3}>
                    <Grid item xs={12}></Grid>
                    <Grid item xs={12}>
                        <OrderDetailReceiptAdd
                            {...props}
                            t={t}
                            classes={classes}
                            AddOrderDetailReceipt={AddOrderDetailReceipt}
                            allowAddReceipt={allowAddReceipt}
                            setAllowAddReceipt={setAllowAddReceipt}
                            setCompletReceipt={setCompletReceipt} />
                    </Grid>
                    <Grid item xs={12}>
                        <DataTable
                            columns={ColumnsOrderDetailReceipt(t, handleDownloadDocument, onOpenModal,ButtonClass)}
                            persistTableHead
                            data={data}
                            customStyles={customStyleSecondary}
                            highlightOnHover
                            pointerOnHover
                            responsive
                            striped
                            pagination
                            paginationComponentOptions={paginationOptions}
                            noHeader
                            expandableRows
                            expandableRowsComponent={<ExpandedComponent />}
                            noDataComponent={<p className={classes.marginNoData}>{t('commonMessages.noData')}</p>} />
                        <br />
                    </Grid>
                </Grid>
            </Container>
        </>
    )
}

const mapStateToProps = state => ({
    userProfile: state.UserProfileReducer.list,
    isUserAuthenticated: state.LoginReducer.isAuthenticated,
    userToken: state.LoginReducer.token,
    userLanguage: state.LoginReducer.language
})

export default connect(mapStateToProps)(withStyles(OtherTransactionsStyles)(OrderDetailReceipt))